<!--  -->
<template>
  <div>
    <div class="title">
      <div class="title-text">原油管道</div>
    </div>
    <div class="textbox">
      <span style="margin-right:90px;margin-left:5px">原油管道今日输油</span>
      <span style="font-size:1.5vh;font-weight: 600;color:#98fef9;margin-right:16px">38.33</span>
      <span style="color: rgba(255, 255, 255, 0.302);">千吨</span>
    </div>
    <div class="contentbox">
      <div class="citem" v-for="(item,i) in 4">
        <div class="top">周平均日输</div>
        <div class="bottom">
          <span style="font-size:2vh;color:#98fef9;margin-right:1vw">39.22</span>
          <span style="color:rgba(255, 255, 255, 0.302);">千吨</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.textbox {
  margin-top: 1vh;
  width: 274px;
  height: 3.3vh;
  background: url(../../assets/textbox2.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  color: #fff;
  font-family: sy;
  font-size: 0.8vh;
}
.contentbox {
  width: 304px;
  height: 12vh;
  margin-top: 1vh;
  //   background: red;
  display: flex;
  flex-wrap: wrap;
  margin-top: 2vh;
  .citem {
    background: url(../../assets/textbox4.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 45%;
    margin-right: 2.5%;
    height: 45%;
    color: #fff;
    margin-bottom: 4%;
    font-size: 1.2vh;
    font-family: sy;
    .top {
      margin-top: 0.2vh;
      margin-bottom: 0.4vh;
      margin-left: 0.5vw;
    }
    .bottom {
      margin-left: 0.5vw;
    }
  }
}
</style>